import $ from 'jquery'
import './main.scss'

$(document).on('click', '[data-action=forum-post-edit]', function (e) {
  let editor
  e.preventDefault()

  const $forumPost = $(this).closest('.forum-post')
  $forumPost.addClass('forum-post--editing')
  if ((editor = $forumPost.find('.mce-content-body').first().data('editor'))) {
    return editor.focus()
  }
})

$(document).on('click', '[data-action=forum-post-editor-cancel]', function (e) {
  e.preventDefault()
  return $(this).closest('.forum-post').removeClass('forum-post--editing')
})
